export default __webpack_public_path__ + "static/media/regulatory--dual-lanes-all-directions-on-left--g1.39024df2.png";